module.exports = __webpack_public_path__ + "static/media/room1_2.75a000c7.JPG";